;
(function ($) {
  var dataKey = 'app.stickyHeader';
  var StickyHeader = function StickyHeader(element, options) {
    this.element = element;
    this.init(options);
  };
  StickyHeader.prototype = {
    value: {
      offset: 50
    },
    classes: {
      fixed: 'header--fixed'
    },
    /**
     * Initialise Sticky Header
     * Adds fixed header if the page is loaded beyond the offset.
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      if ($(window).scrollTop() >= this.value.offset) {
        this._addFixedHeader(this.element);
      }
      this._onWindowScroll();
    },
    /**
     * On Window Scroll
     * Listens for the user scrolling the window.
     * If the window is scrolled beyond the offset the required modifier classes are applied to the element.
     * @private
     */

    _onWindowScroll: function _onWindowScroll() {
      var _this = this;
      var $elm = $(this.element);
      $(window).scroll(function () {
        if ($(window).scrollTop() >= _this.value.offset) {
          _this._addFixedHeader($elm);
        } else {
          _this._removeFixedHeader($elm);
        }
      });
    },
    /**
     * Add Fixed Header
     * Adds the required modifer class to the header to make it fixed.
     * @private
     */

    _addFixedHeader: function _addFixedHeader($elm) {
      $elm.addClass(this.classes.fixed);
    },
    /**
     * Remove Fixed Header
     * Removes the required modifer class which makes the header fixed.
     * @private
     */

    _removeFixedHeader: function _removeFixedHeader($elm) {
      $elm.removeClass(this.classes.fixed);
    }
  };

  /**
   * Global callback function which by default all [data-header] triggers this plugin.
   * @method $.fn.app_stickyHeader()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_stickyHeader();
   */

  $.fn.app_stickyHeader = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof StickyHeader) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new StickyHeader(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);